import { useEffect } from "react";

import { useTaskPoll } from "kanopi-components/useTaskPoll";
import api from "kw/api";
import { GraphQLTypes } from "kw/api/zeus";

export type TusePolicyDocumentsPollArgs = {
  riskProfileId: string;
};

export type TusePolicyDocumentsPoll = {
  documents: GraphQLTypes["QuoteType"]["documents"];
  documentsLoading: boolean;
};

export const usePolicyDocumentsPoll = ({
  riskProfileId,
}: TusePolicyDocumentsPollArgs): TusePolicyDocumentsPoll => {
  const queryPolicyDocumentsStatus = async () => {
    const response = await api.query({
      riskProfile: [
        {
          id: riskProfileId,
        },
        {
          policyDocumentGenerateStatus: true,
        },
      ],
    });
    return response.riskProfile.policyDocumentGenerateStatus;
  };

  const queryPolicyDocuments = async () => {
    const response = await api.query({
      riskProfile: [
        {
          id: riskProfileId,
        },
        {
          policyPeriods: {
            documents: {
              name: true,
              url: true,
            },
          },
        },
      ],
    });
    return (response.riskProfile?.policyPeriods || []).reduce(
      (a, b) => [...a, ...(b?.documents || [])],
      []
    );
  };

  const {
    content,
    loading: documentsLoading,
    taskPoll,
  } = useTaskPoll({
    poll: queryPolicyDocumentsStatus,
    query: queryPolicyDocuments,
  });

  useEffect(() => {
    if (riskProfileId) {
      taskPoll();
    }
  }, []);

  return { documents: content, documentsLoading };
};
